import { createContext, useContext } from "react";

export const ParentContext = createContext(null);

export function useParentScope() {
  const ctx = useContext(ParentContext);
  if (!ctx) throw new Error("useParentScope must be used inside ParentShell");
  return ctx;
}
